import { render, staticRenderFns } from "./AssignTaskForm.vue?vue&type=template&id=52a0a9af&scoped=true"
import script from "./AssignTaskForm.vue?vue&type=script&lang=js"
export * from "./AssignTaskForm.vue?vue&type=script&lang=js"
import style0 from "./AssignTaskForm.vue?vue&type=style&index=0&id=52a0a9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0a9af",
  null
  
)

export default component.exports